import React, { useMemo } from 'react';
import Alert from '@mui/material/Alert';
import useFeature, { useAnyFeatures } from 'hooks/useFeature';

export const defaultErrorMessage = 'You do not have access to this feature.';

const WithFeature = ({ feature, children, message }) => {
  const hasFeatures = useFeature(feature);

  if (!feature) return children;

  if (hasFeatures) {
    return children;
  } else {
    if (message) {
      if (typeof message === 'string') {
        return <Alert severity="error">{message}</Alert>;
      }
      return message;
    }
    return null;
  }
};

export const SomeFeatures = ({ features, message, children }) => {
  const hasSomeFeature = useAnyFeatures(features);

  if (!features || hasSomeFeature) return children;
  if (message) {
    if (typeof message === 'string') {
      return <Alert severity="error">{message}</Alert>;
    }
    return message;
  }
  return null;
};

export default WithFeature;

const WrappedComponent = ({ Component, feature, message, ...props }) => {
  return (
    <WithFeature feature={feature} message={message}>
      <Component {...props} />
    </WithFeature>
  );
};

export const withFeature = (feature, message) => {
  return (Component) => (props) =>
    (
      <WrappedComponent
        {...props}
        Component={Component}
        feature={feature}
        message={message}
      />
    );
};
